export const REQUEST_VOICES = 'Speech/REQUEST_VOICES';
export const RECEIVE_VOICES = 'Speech/RECEIVE_VOICES';
export const CHANGE_VOICE = 'Speech/CHANGE_VOICE';
export const CHANGE_PITCH = 'Speech/CHANGE_PITCH';
export const CHANGE_RATE = 'Speech/CHANGE_RATE';
export const CHANGE_VOLUME = 'Speech/CHANGE_VOLUME';
export const START_SPEECH = 'Speech/START_SPEECH';
export const END_SPEECH = 'Speech/END_SPEECH';
export const CANCEL_SPEECH = 'Speech/CANCEL_SPEECH';
export const LOG_TTS = 'Speech/LOG_TTS';
export const CHECK_SPEECH_API = 'Speech/CHECK_SPEECH_API';
export const CHECK_INTL_API = 'Speech/CHECK_INTL_API';



// WEBPACK FOOTER //
// ./src/providers/SpeechProvider/SpeechProvider.constants.js